import { render } from "./trainStat.vue?vue&type=template&id=1c7aec1f&scoped=true"
import script from "./trainStat.vue?vue&type=script&lang=js"
export * from "./trainStat.vue?vue&type=script&lang=js"

import "./trainStat.vue?vue&type=style&index=0&id=1c7aec1f&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7aec1f"]])

export default __exports__